import React from 'react'

export default function GouSewa() {
    return (
        <div>GouSewa</div>
    )
}
